import graphqlClient from './client';
import gql from 'graphql-tag';

export const query = gql`
  query CandidatePreviousAppsByEmail($positionId: ID!, $email: String!) {
    candidatePreviousAppsByEmail(positionId: $positionId, email: $email) {
      candidateDetails {
        id
        email
        firstName
        lastName
        phone
        mostRecentJobTitle
        mostRecentCompanyName
        timeInRoleYears
        timeInRoleMonths
        isNewToWorkforce
        previousResume {
          prospectId
          attachmentId
          fileName
        }
        previousCoverLetter {
          prospectId
          attachmentId
          fileName
        }
      }
      mostRecentApplication {
        dateApplied
        jobTitle
        alreadyAppliedForThisPosition
      }
    }
  }
`;

const fetchCandidatePreviousAppsByEmail = async (
  positionId: number,
  email: string,
) => {
  if (email === '') {
    throw new Error('Error fetching candidate details - No email was provided');
  }
  const { data } = await graphqlClient.query({
    variables: { positionId, email },
    query,
  });
  if (data === null) {
    throw new Error(
      'Error fetching candidate details - Data was return as null',
    );
  }

  return data;
};

export default fetchCandidatePreviousAppsByEmail;
